import { render, staticRenderFns } from "./sendReportModal.vue?vue&type=template&id=bd66dee0&"
import script from "./sendReportModal.vue?vue&type=script&lang=js&"
export * from "./sendReportModal.vue?vue&type=script&lang=js&"
import style0 from "./sendReportModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports